import React from 'react';
import helpBlue from '../../assets/images/icons/blue-help.png';
import PersonalDetails from './personalDetails';
import LoyaltyPersonalDetails from './loyaltyPersonalDetails';
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';
class UserAccount extends React.Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.preferredLocation_TokenAPI();
    this.props.yearCalculationFun();
    this.props.get_StateJson()
  };

  render() {
    return (
      <section className="cmx-user-account-page">
        <Helmet>
          <title>{metatags.commonMetatag.title}</title>
          <meta name="description" content={metatags.commonMetatag.description} />
        </Helmet>
        <section className="row">
            <section className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <aside className='head text-center pt-4 pb-4'>
                <h1><span className='txt-top d-block'>User Account</span></h1>
              </aside>
            </section>
            <section className='us-container'>
              <section className='tabs-blk'>
                <div className="nav nav-tabs" role="tablist">
                  <button onClick={this.props.loginTab} className={`login-tab nav-link ${this.props.state.memberIDTabsSH ? '':'active'}`} id="login-tab" data-bs-toggle="tab" data-bs-target="#login" type="button" role="tab" aria-controls="login" aria-selected="true">login <span>Hello! Welcome to CMX Cinemas</span></button>
                  <button onClick={this.props.signUpTab} className={`signup-tab nav-link ${this.props.state.memberIDTabsSH ? 'active':''}`} id="signup-tab" data-bs-toggle="tab" data-bs-target="#signup" type="button" role="tab" aria-controls="signup" aria-selected="false">sign up <span>Fill in this form to create an account</span></button>
                </div>

                <section className="tab-content" id="nav-tabContent">
                  <section className={`tab-pane fade ${this.props.state.memberIDTabsSH ? '':'active show'}`} id="login" role="tabpanel" aria-labelledby="login-tab">
                    <section className='signin-form'>
                      {
                        this.props.state.forgotSH == false &&
                        <section className='signin-inner'>
                          <h2>Sign in to your CMX Account</h2>
                          <aside className='form-blk'>
                            <aside className='from-group email-icon'>
                              <aside className='form-inner'>
                                <input 
                                  type="email" 
                                  placeholder='Enter your email address' 
                                  autoComplete="off"
                                  name="signInEmailValue"
                                  onChange={this.props.signIn_emailOnchange}
                                  onBlur={this.props.signIn_emailOnblur}
                                  value={this.props.state.signInEmailValue}
                                  onKeyPress={this.props.login_enterKey}
                                />
                              </aside>
                              <p className='error-msg'>{this.props.state.signInEmailErrorMsg}</p>
                            </aside>
                            <aside className={`from-group lock-icon ${this.props.state.eyeIcon ? 'show':''}`}>
                              <aside className='form-inner'>
                                <input 
                                  type={`${this.props.state.eyeIcon ? 'text':'password'}`} 
                                  placeholder='Enter your password' 
                                  autoComplete="off"
                                  name="signInPasswordValue"
                                  onChange={this.props.signIn_passwordOnchange}
                                  onBlur={this.props.signIn_passwordOnblur}
                                  value={this.props.state.signInPasswordValue}
                                  onKeyPress={this.props.login_enterKey}
                                  maxLength="20"
                                />
                                <span onClick={(e) => this.props.ua_eyeIcon('login')} className='eye-icon'>&nbsp;</span>
                              </aside>
                              <p className='error-msg'>{this.props.state.signInPasswordErrorMsg}</p>
                            </aside>
                          </aside>
                          <aside className='login-btn-group'>
                            <aside className="cmx-flex-btn-group text-start">
                              <a onClick={this.props.loginBtnClick} className={`flex-btn ${this.props.loginBtnDisabled() ? 'disabled':''}`} href="javascript:;" title="LOGIN"><span>login</span></a>
                            </aside>
                            <aside className='rgt'>
                              <a onClick={this.props.forgotPassword} className='text-decoration-underline' href='javascript:;' title='Forgot password?'>Forgot password?</a>
                            </aside>
                          </aside>
                        </section>
                      }

                      {/* Forgot password > start */}
                      {
                        this.props.state.forgotSH &&
                        <section className='signin-inner forgot-blk'>
                          <h2>Forgot password</h2>
                          <aside className='form-blk'>
                            <aside className='from-group email-icon'>
                              <aside className='form-inner'>
                                <input 
                                  type="email" 
                                  placeholder='Enter your email address' 
                                  autoComplete="off"
                                  name="forgotEmailValue"
                                  onChange={this.props.forgot_emailOnchange}
                                  onBlur={this.props.forgot_emailOnblur}
                                  value={this.props.state.forgotEmailValue}
                                  />
                              </aside>
                              <p className='error-msg'>{this.props.state.forgotEmailErrorMsg}</p>
                            </aside>
                          </aside>
                          <aside className='login-btn-group'>
                            <aside className="cmx-flex-btn-group text-start">
                              <a onClick={this.props.forgotContineBtn} className={`flex-btn ${this.props.forgotContinueDisable() ? 'disabled':''}`} href="javascript:;" title="CONTINUE"><span>continue</span></a>
                            </aside>
                          </aside>
                          <aside className='login-blk'>
                            <p>Already have an account <a onClick={this.props.forgot_loginClick} href="javascript:;" title='Login'>Login</a></p>
                          </aside>
                        </section>
                      }
                      {/* Forgot password > end */}

                    </section>
                  </section>
                  <section className={`tab-pane fade ${this.props.state.memberIDTabsSH ? 'active show':''}`} id="signup" role="tabpanel" aria-labelledby="signup-tab">
                    <section className='signup-blk'>
                      {/* <div className="nav nav-tabs" role="tablist">
                        <button onClick={this.props.joinCMXTab} className="nav-link active" id="join-tab" data-bs-toggle="tab" data-bs-target="#join" type="button" role="tab" aria-controls="join" aria-selected="true">
                          <aside className='form-group'>
                            <input type="radio" name="signup-form" id="join-input" defaultChecked />
                            <label htmlFor="join-input">
                              <p>Join CMX Rewards</p>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </button>
                        <button className="nav-link" id="rewards-tab" data-bs-toggle="tab" data-bs-target="#rewards" type="button" role="tab" aria-controls="rewards" aria-selected="false">
                          <aside className='form-group'>
                            <input type="radio" name="signup-form" id="rewards-input" />
                            <label htmlFor="rewards-input">
                              <p>I am a <span className="mob-clud">Club Ciné/<i>MovieGoer/Liberty</i></span> Rewards member</p>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </button>
                      </div> */}
                      <section className="tab-content" id="nav-tabContent">
                        <section className="tab-pane fade active show" id="join" role="tabpanel" aria-labelledby="join-tab">
                          <PersonalDetails 
                            state={this.props.state}
                            ua_eyeIcon={this.props.ua_eyeIcon}
                            stateValue={this.props.stateValue}
                            homePhoneNum={this.props.homePhoneNum}
                            us_hpnOnchange={this.props.us_hpnOnchange} 
                            us_hpnStateOnchange={this.props.us_hpnStateOnchange} 
                            month={this.props.month} 
                            ua_birthMonthOnchange={this.props.ua_birthMonthOnchange} 
                            date={this.props.date} 
                            year={this.props.year} 
                            an_month={this.props.an_month}
                            an_date={this.props.an_date}
                            an_year={this.props.an_year}
                            ua_dateOnchange={this.props.ua_dateOnchange} 
                            ua_yearOnchange={this.props.ua_yearOnchange} 
                            ua_cinemaOnchange={this.props.ua_cinemaOnchange} 
                            cinemaLocation={this.props.cinemaLocation} 
                            ua_an_monthOnchange={this.props.ua_an_monthOnchange}
                            ua_an_dateOnchange={this.props.ua_an_dateOnchange}
                            ua_an_yearOnchange={this.props.ua_an_yearOnchange}
                            ua_counterBtnClick={this.props.ua_counterBtnClick}
                            ua_passwordPolicyFocus={this.props.ua_passwordPolicyFocus}
                            ua_passwordPolicyBlur={this.props.ua_passwordPolicyBlur}
                            otp_ModalClick={this.props.otp_ModalClick}
                            TandC_componentClick={this.props.TandC_componentClick}
                            NameOnChange={this.props.NameOnChange}
                            fnOnblur={this.props.fnOnblur}
                            lnOnblur={this.props.lnOnblur}
                            signUp_emailOnchange={this.props.signUp_emailOnchange}
                            signUp_emailOnblur={this.props.signUp_emailOnblur}
                            signUp_PasswordOnchangeFun={this.props.signUp_PasswordOnchangeFun}
                            signUp_ConfirmPasswordOnchangeFun={this.props.signUp_ConfirmPasswordOnchangeFun}
                            signUp_ConfirmPasswordPolicyBlur={this.props.signUp_ConfirmPasswordPolicyBlur}
                            ua_addressOnchange={this.props.ua_addressOnchange}
                            ua_zipCodeOnchange={this.props.ua_zipCodeOnchange}
                            ua_zipCodeOnBlur={this.props.ua_zipCodeOnBlur}
                            tc_AcceptClick={this.props.tc_AcceptClick}
                            tc_AgreeClick={this.props.tc_AgreeClick}
                            signUp_mobileOnchangeFun={this.props.signUp_mobileOnchangeFun}
                            signUp_mobileBlur={this.props.signUp_mobileBlur}
                            signupBtnDisabled={this.props.signupBtnDisabled}
                            withoutMMR_signupBtn={this.props.withoutMMR_signupBtn}
                            withoutMMR_signupDisabled={this.props.withoutMMR_signupDisabled}
                            get_StateJson={this.props.get_StateJson}
                          />
                        </section>
                        {/* <section className="tab-pane fade" id="rewards" role="tabpanel" aria-labelledby="rewards-tab">
                          <section className='rewards-blk'>
                            <section className='re-head'>
                              <h2>What do you have with you? <span>* Required</span></h2>
                            </section>
                              <section className='re-list'>
                                <ul>
                                  {
                                    this.props.state.ua_rewardsTab.map((reData, index) => {
                                      return(
                                        <li className={`${(this.props.state.ua_rewardsTabIndex == index) || ((index == 0) && (this.props.state.ua_rewardsTabIndex == -1)) ? 'active':''}`} onClick={(e) => this.props.ua_rewardsTabClick(e, index)} key={index}><a href="javascript:;" title={reData}><span>{reData}</span></a></li>
                                      )
                                    })
                                  }
                                </ul>
                              </section>
                              
                              {
                                (this.props.state.ua_rewardsTabIndex == -1) || (this.props.state.ua_rewardsTabIndex == 0) ?
                                  <section className='card-type-blk'>
                                    <h2>What is your card type?</h2>
                                    <ul>
                                      {
                                        this.props.state.whatCardType.map((cardData, index) => {
                                          return(
                                            <li key={index}>
                                              <aside className="form-group">
                                                {
                                                  index == 0 ? 
                                                    <input onChange={(e) => this.props.cardTypeOnChange(e, cardData)} type="radio" name="card-type" id={`card-type-${index}`} defaultChecked />
                                                  :
                                                    <input onChange={(e) => this.props.cardTypeOnChange(e, cardData)} type="radio" name="card-type" id={`card-type-${index}`} />
                                                }
                                                <label for={`card-type-${index}`}>
                                                  <p>{cardData.title}</p><span className="radio-btn">&nbsp;</span>
                                                </label>
                                              </aside>
                                            </li>
                                          )
                                        })
                                      }
                                    </ul>
                                  </section>
                                  :
                                  ''
                              }

                              <section className='re-form-blk'>
                                <aside className='lft'>
                                  <aside className='lft-inner'>
                                    <input 
                                      type={`${(this.props.state.ua_rewardsTabIndex == 1) ? 'tel':`${this.props.state.ua_rewardsTabIndex == 2 ? 'email':'text'}`}`} 
                                      placeholder={`${this.props.state.ua_rewardsPlaceholder}`} 
                                      autoComplete="off"
                                      name="LltyMoleEmail_Value"
                                      onChange={(e) => this.props.loyaltyOnchange(e, this.props.state.ua_rewardsTabIndex)}
                                      onBlur={(e) => this.props.loyltyOnblur(e, this.props.state.ua_rewardsTabIndex)}
                                      value={this.props.state.LltyMoleEmail_Value}
                                      />
                                  </aside>
                                  <p className='error-msg'>{this.props.state.loyltyErrorMsg}</p>
                                </aside>
                                <aside className='rgt'>
                                  <aside className="cmx-flex-btn-group text-end">
                                    <a onClick={this.props.loyaltyCheckBtn} className={`flex-btn ${this.props.loyaltyCheckDisabled() ? 'disabled':''} ${this.props.state.checkBtnActive ? 'active':''}`} title="CHECK" href="javascript:;"><span>{this.props.state.checkBtnActive ? 'checked':'check'}</span></a>
                                  </aside>
                                </aside>
                              </section>
                            </section>
                          {
                            this.props.state.check_PD_ComponentSH &&
                              <LoyaltyPersonalDetails 
                                state={this.props.state}
                                ua_eyeIcon={this.props.ua_eyeIcon}
                                stateValue={this.props.stateValue}
                                homePhoneNum={this.props.homePhoneNum}
                                us_hpnOnchange={this.props.us_hpnOnchange} 
                                us_hpnStateOnchange={this.props.us_hpnStateOnchange} 
                                month={this.props.month} 
                                ua_birthMonthOnchange={this.props.ua_birthMonthOnchange} 
                                date={this.props.date} 
                                year={this.props.year} 
                                an_month={this.props.an_month}
                                an_date={this.props.an_date}
                                an_year={this.props.an_year}
                                ua_dateOnchange={this.props.ua_dateOnchange} 
                                ua_yearOnchange={this.props.ua_yearOnchange} 
                                ua_cinemaOnchange={this.props.ua_cinemaOnchange} 
                                cinemaLocation={this.props.cinemaLocation} 
                                ua_an_monthOnchange={this.props.ua_an_monthOnchange}
                                ua_an_dateOnchange={this.props.ua_an_dateOnchange}
                                ua_an_yearOnchange={this.props.ua_an_yearOnchange}
                                ua_counterBtnClick={this.props.ua_counterBtnClick}
                                ua_passwordPolicyFocus={this.props.ua_passwordPolicyFocus}
                                ua_passwordPolicyBlur={this.props.ua_passwordPolicyBlur}
                                otp_ModalClick={this.props.otp_ModalClick}
                                TandC_componentClick={this.props.TandC_componentClick}
                                NameOnChange={this.props.NameOnChange}
                                fnOnblur={this.props.fnOnblur}
                                lnOnblur={this.props.lnOnblur}
                                signUp_emailOnchange={this.props.signUp_emailOnchange}
                                signUp_emailOnblur={this.props.signUp_emailOnblur}
                                signUp_PasswordOnchangeFun={this.props.signUp_PasswordOnchangeFun}
                                signUp_ConfirmPasswordOnchangeFun={this.props.signUp_ConfirmPasswordOnchangeFun}
                                signUp_ConfirmPasswordPolicyBlur={this.props.signUp_ConfirmPasswordPolicyBlur}
                                ua_addressOnchange={this.props.ua_addressOnchange}
                                ua_zipCodeOnchange={this.props.ua_zipCodeOnchange}
                                ua_zipCodeOnBlur={this.props.ua_zipCodeOnBlur}
                                tc_AcceptClick={this.props.tc_AcceptClick}
                                tc_AgreeClick={this.props.tc_AgreeClick}
                                signUp_mobileOnchangeFun={this.props.signUp_mobileOnchangeFun}
                                signUp_mobileBlur={this.props.signUp_mobileBlur}
                                signupBtnDisabled={this.props.signupBtnDisabled}
                                withoutMMR_signupBtn={this.props.withoutMMR_signupBtn}
                                withoutMMR_signupDisabled={this.props.withoutMMR_signupDisabled}
                                loyaltySignUpBtnDisabled={this.props.loyaltySignUpBtnDisabled}
                                loyaltySignUpBtnOnClick={this.props.loyaltySignUpBtnOnClick}
                                get_StateJson={this.props.get_StateJson}
                              />
                          }
                        </section> */}
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
            
          </section>

          {/* Footer > start */}
        <section className='footer-price-blk'>
          <section className='content'>
            <section className='lft'>
              <p className='desktop'>Total Price<i>:</i> <span>${this.props.state.planPrice}
                <em> {this.props.state.choosePlanName} 
                  {/* <img src={helpBlue} alt="Help" className="img-fluid" /> */}
                </em>
              </span></p>
            </section>
            {/* <section className='rgt'>
              <aside className="cmx-flex-btn-group text-end">
                <a className="flex-btn" href="javascript:;" title="CONTINUE"><span>Continue</span></a>
              </aside>
            </section> */}
          </section>
        </section>
        {/* Footer > end */}

      </section>
    )
  }
}

export default UserAccount;